 "use client";

import { useEffect, useState } from "react";
import { c444FormatIntegerCount } from "@/constants/appFacts";

const STORAGE_COUNT_KEY = "c444-active-players-count-v2";
const LEGACY_STORAGE_COUNT_KEY = "c444-active-players-count";
const START_COUNT = 10_000;
const TICK_MS = 4_000;
const STEP_PER_TICK = 2;
const CEILING = 999_999;

function clampCount(value: number): number {
  return Math.min(CEILING, Math.max(START_COUNT, value));
}

function getSyncedCount(nowMs: number): number {
  void nowMs;
  const savedCountRaw = window.localStorage.getItem(STORAGE_COUNT_KEY);
  const savedCount = Number(savedCountRaw);
  if (!Number.isFinite(savedCount)) {
    return START_COUNT;
  }
  return clampCount(savedCount);
}

function persistCount(count: number, nowMs: number): void {
  void nowMs;
  window.localStorage.setItem(STORAGE_COUNT_KEY, String(count));
}

export default function ActivePlayersCounter() {
  const [count, setCount] = useState(START_COUNT);

  useEffect(() => {
    const now = Date.now();
    window.localStorage.removeItem(LEGACY_STORAGE_COUNT_KEY);
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const syncedCount = getSyncedCount(now);
    setCount(syncedCount);
    persistCount(syncedCount, now);

    if (mq.matches) {
      return undefined;
    }

    const id = window.setInterval(() => {
      const tickNow = Date.now();
      setCount((prev) => {
        const nextCount = clampCount(prev + STEP_PER_TICK);
        persistCount(nextCount, tickNow);
        return nextCount;
      });
    }, TICK_MS);

    return () => window.clearInterval(id);
  }, []);

  return (
    <span className="tabular-nums">
      {c444FormatIntegerCount(count)}
    </span>
  );
}
